class SizeGuide extends HTMLElement {
  constructor() {
    super();

    this.sizeGuideContent = document.querySelector('[data-size-guide-content]');
    this.sizeGuideCsvDiv;
    this.hasCM = false;
    this.hasIN = false;
    new theme.Drawers('SizeGuideDrawer', 'size-guide-drawer');
  }

  connectedCallback() {
    this.moveContentToDrawer();
  }

  moveContentToDrawer() {
    this.append(this.sizeGuideContent);
    this.sizeGuideContent.classList.remove('hide');
    this.getSizeGuideInfo();
  }

  getSizeGuideInfo() {
    this.sizeGuideCsvDiv = this.querySelector('[data-size-guide-csv]');
    if(this.sizeGuideCsvDiv) {
      const cmCsv = this.sizeGuideCsvDiv.dataset.csvCm;
      const inCsv = this.sizeGuideCsvDiv.dataset.csvIn;
      if(cmCsv != '') {
        this.hasCM = true;
        this.getCSVData(cmCsv, 'CM')
      }
      if(inCsv != '') {
        this.hasIN = true;
        this.getCSVData(inCsv, 'IN')
      }
    }
    this.renderMetricToggle();
  }

  getCSVData(csv, type) {
    Papa.parse(csv, {
      download: true,
      delimiter: ",",
      header: true,
      complete: (results) => {
        this.renderSizeHtml(results.data, type);
      }
    });
  }

  renderSizeHtml(data, type) {
    if(data.length) {
      let showByDefault = false;
      if(type == "CM") {
        showByDefault = true;
      } else {
        if(!this.hasCM) {
          showByDefault = true;
        }
      }
      let sizeGuideHeader = '';
      let sizeGuideRows = '';
      let columnCount = Object.keys(data[0]).length;
      data.forEach((item, index) => {
        if(index === 0) {
          for (const [key, value] of Object.entries(item)) {
            sizeGuideHeader += `<div class="size-guide-cell">${key}</div>`;
          }
        }
        sizeGuideRows += `<div class="size-guide-row">`;
        for (const [key, value] of Object.entries(item, index)) {
          sizeGuideRows += `<div class="size-guide-cell">${value}</div>`;
        }
        sizeGuideRows += `</div>`;
      })
      
      let sizeHtml = `
        <div class="size-guide-table${showByDefault ? ' active' : ''}${ columnCount > 4 ? ' table-overflow-mobile' : ''}" data-size-type="${type}" style="--colCount: ${columnCount}">
          <div class="size-guide-header-row">${sizeGuideHeader}</div>
          <div class="size-guide-rows">${sizeGuideRows}</div>
        </div>
      `;
      const div = document.createElement('div');
      div.innerHTML = sizeHtml;
      this.sizeGuideCsvDiv.append(div);
    }
  }

  renderMetricToggle() {
    let toggleHtml = `<div class="size-guide-toggle text-center">`;
    if(this.hasCM) {
      toggleHtml += `<button type="button" class="btn active" data-target="CM">CM</button>`;
    }
    if(this.hasIN) {
      let classes = "btn"
      if(!this.hasCM) {
        classes += " active";
      }
      toggleHtml += `<button type="button" class="${classes}" data-target="IN">IN</button>`;
    }
    toggleHtml += `
      </div>
      <div class="size-guide-toggle-info text-center">
    `;
    if(this.hasCM) {
      toggleHtml += `<p class="size-guide-toggle-info__text active" data-size-type="CM">Measure in Centimetres</p>`;
    }
    if(this.hasIN) {
      let classes = "size-guide-toggle-info__text";
      if(!this.hasCM) {
        classes += " active";
      }
      toggleHtml += `<p class="${classes}" data-size-type="IN">Measure in Inches</p>`;
    }
    toggleHtml += `</div>`;

    const div = document.createElement('div');
    div.innerHTML = toggleHtml;
    this.sizeGuideCsvDiv.prepend(div);

    this.addToggleEventListener();
  }

  addToggleEventListener() {
    const toggleBtns = this.querySelectorAll('.size-guide-toggle button');
    if(toggleBtns.length) {
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const target = e.target.dataset.target;
          const infoEl = this.querySelector(`.size-guide-toggle-info__text[data-size-type="${target}"`);
          const sizeguide = this.querySelector(`.size-guide-table[data-size-type="${target}"]`);
          const activeInfoEl = this.querySelector(".size-guide-toggle-info__text.active");
          const activeSizeGuide = this.querySelector(".size-guide-table.active");
          const activeBtn = this.querySelector('.size-guide-toggle button.active');

          activeInfoEl.classList.remove('active')
          activeSizeGuide.classList.remove('active');
          infoEl.classList.add('active');
          sizeguide.classList.add('active');
          activeBtn.classList.remove('active');
          e.target.classList.add('active');
        })
      })
    }
  }

}

customElements.define('size-guide', SizeGuide);
